<router-outlet (activate)="onActivate($event)"></router-outlet>

<ngx-spinner bdColor="rgba(51,51,51,0.2)" size="medium" color="#fff" type="ball-scale-multiple">
</ngx-spinner>